<!-- Zweck: Stellt die HTML-Struktur für shop artikel aktionen button component im Frontend bereit. -->
@if (popupMode && (aktionen|async)?.length > 0) {
  <button mat-icon-button type="button" class="aktion-popup-button" (click)="openPopup()" matTooltip="Aktionsdetails anzeigen"
          aria-label="Aktionsdetails anzeigen">%</button>
}
<ng-template #actionPopup>
  <h2 mat-dialog-title>Aktionen für {{artikel.label}}</h2>
  <mat-dialog-content>
    <artikel-aktionen-details class="no-wrap" [noWrap]="true" [showActionDate]="false"
      [aktionen]="getPopupAktionen()"
      [directAddToWarenkorb]="!(view.settings && view.settings.bestellblock_mode) && !['NE', 'AV', 'NG'].includes(artikel.VerfuegbarkeitsstatusCode)">
    </artikel-aktionen-details>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Schließen</button>
  </mat-dialog-actions>
</ng-template>
@if (!popupMode && (aktionen|async)?.length > 0 && (viewcomp.visible_artikel_aktionen|async)) {
  <div>
    @if (!(viewcomp.visible_artikel_aktionen|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
      <button (click)="showAktionen(artikel)"
        mat-icon-button
        matTooltip="Anzeigen">
        <svg-icon>plus</svg-icon>
      </button>
    }
    @if ((viewcomp.visible_artikel_aktionen|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
      <button (click)="hideAktionen(artikel)"
        mat-icon-button
        matTooltip="Ausblenden">
        <svg-icon>minus</svg-icon>
      </button>
    }
  </div>
}


